import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ReportDashboardConfig, UserProfileReporting } from '@liquitics/transaction';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { AppConfig } from '../app.config';
import { AwsUtil } from '../authentication/aws.service';
import { DashboardLayoutBuilderComponent } from './dashboard-layout/dashboard-layout-builder.component';
import { ReportDashboardPermissionComponent } from './permission/report-dashboard-permission.component';

@Component({
    selector: 'app-report-dashboard-config',
    templateUrl: './report-dashboard-config.component.html',
    styleUrls: ['./report-dashboard-config.component.scss']
})
export class ReportDashboardConfigComponent implements OnInit {

    @ViewChild('builder', { static: false }) builderComponent: DashboardLayoutBuilderComponent;
    @ViewChild('permission', { static: false }) permissionComponent: ReportDashboardPermissionComponent;

    scheduleTypes = [
        { label: 'None', value: 'NONE' },
        { label: 'Daily', value: 'DAILY' },
        { label: 'Start of Month', value: 'START_OF_MONTH' },
        { label: 'End of Month', value: 'END_OF_MONTH' },
        { label: 'Start of Quarter', value: 'START_OF_QUARTER' },
        { label: 'End of Quarter', value: 'END_OF_QUARTER' },
        { label: 'Start of Year', value: 'START_OF_YEAR' },
        { label: 'End of Year', value: 'END_OF_YEAR' },
        { label: 'Sunday', value: 'SUNDAY' },
        { label: 'Monday', value: 'MONDAY' },
        { label: 'Tuesday', value: 'TUESDAY' },
        { label: 'Wednesday', value: 'WEDNESDAY' },
        { label: 'Thursday', value: 'THURSDAY' },
        { label: 'Friday', value: 'FRIDAY' },
        { label: 'Saturday', value: 'SATURDAY' }
    ];
    separatorKeysCodes: number[] = [ENTER, COMMA];
    reportDashboardConfig: ReportDashboardConfig;
    formGroup: FormGroup;

    license: any;

    currentUser: string;
    designers: string[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private appConfig: AppConfig,
        private awsUtil: AwsUtil,) {
        this.reportDashboardConfig = data.reportDashboardConfig;
        this.designers = data.designers;
        const reportingProfile: UserProfileReporting = this.appConfig.activeUserProfile as UserProfileReporting;
        this.license = reportingProfile.getLicense();
        this.currentUser = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
        this.formGroup = new FormGroup({
            'identifier': new FormControl(this.reportDashboardConfig.identifier, [
            ]
            ),
            'name': new FormControl(this.reportDashboardConfig.name, [
                Validators.required,
                Validators.maxLength(32),
            ]
            ),
            'title': new FormControl(this.reportDashboardConfig.title, [
                Validators.required,
                Validators.maxLength(128),
            ]
            ),
            'schedule': new FormControl(this.reportDashboardConfig.publishingConfig.schedule, [
            ]
            ),
            'emailRecipients': new FormControl(this.reportDashboardConfig.publishingConfig.emailRecipients, [
            ]
            ),
            'emailFormat': new FormControl(this.reportDashboardConfig.publishingConfig.emailFormat, [
            ]
            ),
            'autoPublish': new FormControl(this.reportDashboardConfig.publishingConfig.autoPublish, [
            ]
            ),
            'viewableOnline': new FormControl(this.reportDashboardConfig.publishingConfig.viewableOnline, [
            ]
            ),
            // 'owner': new FormControl(this.reportDashboardConfig.meta?.owner || '', [
            // ]
            // ),
            // 'collaborators': new FormControl(this.reportDashboardConfig.meta?.collaborators || [], [
            // ]
            // ),
            // 'viewers': new FormControl(this.reportDashboardConfig.meta?.viewers || [], [
            // ]
            // ),
            'layoutMode': new FormControl(this.reportDashboardConfig.viewConfig?.layoutMode || 'AUTOMATIC', [
            ]
            ),
        });
    }
    ngOnInit() {
    }

    get identifier() { return this.formGroup.get('identifier'); }
    get name() { return this.formGroup.get('name'); }
    get title() { return this.formGroup.get('title'); }
    get schedule() { return this.formGroup.get('schedule'); }
    get emailRecipients() { return this.formGroup.get('emailRecipients'); }
    get emailFormat() { return this.formGroup.get('emailFormat'); }
    get autoPublish() { return this.formGroup.get('autoPublish'); }
    get viewableOnline() { return this.formGroup.get('viewableOnline'); }
    get owner() { return this.formGroup.get('permissions').get('owner'); }
    get publisher() { return this.formGroup.get('permissions').get('publisher'); }
    get collaborators() { return this.formGroup.get('permissions').get('collaborators'); }
    get viewers() { return this.formGroup.get('permissions').get('viewers'); }
    get layoutMode() { return this.formGroup.get('layoutMode'); }

    addFormControl(name: string, fg: FormGroup): void {
        this.formGroup.addControl(name, fg);
    }

    onOKButton() {
        this.reportDashboardConfig.name = this.name.value;
        this.reportDashboardConfig.title = this.title.value;
        if (this.emailFormat.value === 'NONE') {
            this.reportDashboardConfig.publishingConfig.sendEmail = false;
            this.reportDashboardConfig.publishingConfig.emailFormat = 'NONE';
            this.reportDashboardConfig.publishingConfig.emailRecipients = [];
        } else {
            this.reportDashboardConfig.publishingConfig.sendEmail = true;
            this.reportDashboardConfig.publishingConfig.emailFormat = this.emailFormat.value;
        }
        this.reportDashboardConfig.publishingConfig.schedule = this.schedule.value;
        this.reportDashboardConfig.publishingConfig.autoPublish = this.autoPublish.value;
        // Handle Layouts
        this.reportDashboardConfig.viewConfig = this.reportDashboardConfig.viewConfig || {} as any;
        this.reportDashboardConfig.viewConfig.layoutMode = this.layoutMode.value;
        if (this.reportDashboardConfig.viewConfig.layoutMode === 'AUTOMATIC') {
            this.reportDashboardConfig.componentConfigs
                .forEach((cc) => {
                    delete cc.layout;
                });
        } else {
            this.builderComponent.finalizeToComponentLayouts();
        }
        this.reportDashboardConfig.meta = this.reportDashboardConfig.meta || {} as any;
        this.reportDashboardConfig.meta.owner = this.owner.value;
        this.reportDashboardConfig.meta.publisher = this.publisher.value;
        this.reportDashboardConfig.meta.collaborators = this.collaborators.value;
        this.reportDashboardConfig.meta.viewers = this.viewers.value;
    }
    addEmail(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.reportDashboardConfig.publishingConfig.emailRecipients.push(value.trim());
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
    removeEmail(emailAddress: string): void {
        const index = this.reportDashboardConfig.publishingConfig.emailRecipients.indexOf(emailAddress);
        if (index >= 0) {
            this.reportDashboardConfig.publishingConfig.emailRecipients.splice(index, 1);
        }
    }
}
